let path = "https://cep360.kestoneapps.in";
if (process.env.NODE_ENV === "development") {
  path = "http://localhost:4020";
}
export const method = {
  post: "post",
  put: "put",
  get: "get",
  delete: "delete",
  patch: "patch",
};
// export const basePath = "https://cep360.kestoneapps.in";
// export const apiPath = "/api";
export const basePath = path;
export const apiPath = basePath + "/api";

export const apiLoginUser = "/auth/login";
export const apiAuthResetPassword = "/auth/resetPassword";
export const apiLogutUser = "/auth/logout";
export const apiGetUser = "/auth/user";
export const apiGetAllUsers = "/auth/allusers";
export const apiRegisterUser = "/auth/register";
export const apiUpdateUser = "/auth/user";
export const apiGetUserByRole = "/auth/users-by-role";
export const apiBulkCreateAgents = "/auth/bulk-create-agents";
export const apiChangeOwnPassword = "/auth/change-password";
export const apiUpdateOwnPan = "/auth/update-pan";
export const apiDismissPanAlert = "/auth/dismiss-pan-alert";
export const apiCreateCampaign = "/campaign/create";
export const apiUpdateCampaign = "/campaign/update";
export const apiVersaValidate     = "/campaign/virsa-validate";
export const apiVersaEmailStatus  = "/campaign/virsa-email-status";
export const apiGetCampaigns = "/campaign/allCampaigns";
export const apiGetCampaignsById = "campaign/getCampaignByUserId";
export const apiGetCampaignDetailsByCampaignId = "/campaign/getCampaignById";

export const apiUploadDatabase = "/callingData/upload-database";
export const apiExternalUpload = "/callingData/external-upload";
export const apiExternalUploadTemplate = "/callingData/external-upload-template";
export const apiExternalCallingDataUpload = "/callingData/external-calling-data-upload";
export const apiExternalCallingDataTemplate = "/callingData/external-calling-data-template";
export const apiGetCampaignDatabase = "/callingData/getAllCallingData";
export const campaignDataByAssignment = "/callingData/campaignDataByAssignment";
export const campaignDataByAssignmentUnmasked =
  "/callingData/campaignDataByAssignmentUnmasked";

export const apiGetCallingDataById = "/callingData/getCallingDataById";
export const apiUpdateCallingData = "/callingData";
export const apiUpdateDirectCallingData = "/callingData/updateCallingData";
export const apiAgentLiveStatus = "/tataCalling/agentLiveStatus";

// IT Administrator — Asset management
export const apiAsset             = "/asset";
export const apiAssetStats        = "/asset/stats";
export const apiAssetPMReport     = "/asset/pm-report";
export const apiAssetAgentOptions = "/asset/dropdown/agents";
export const apiAssetPMOptions    = "/asset/dropdown/pms";
export const apiAddSingleContact = "/callingData/addContact";
export const apiSetPriority = "/callingData/setPriority";
export const apiGetPriorityList = "/callingData/getPriorityList";
// Campaign-level priority groups
export const apiPriorityBase = "/callingData"; // append /:campaignId/priorityXxx
export const apiDistinctCampaignCompanies  = (campaignId) => `/callingData/${campaignId}/distinctCompanies`;
export const apiMatchCampaignCompanyNames  = (campaignId) => `/callingData/${campaignId}/matchCompanyNames`;
export const apiApplyCompanyExclusion      = (campaignId) => `/callingData/${campaignId}/applyCompanyExclusion`;
export const apiAssignExclusionPriority    = (campaignId) => `/callingData/${campaignId}/assignExclusionPriority`;
export const apiClosePriority = "/callingData/closePriority";
//external registrations api
export const apiUploadExternalRegistrations =
  "/callingData/externalRegistrationData";
export const apiGetExternalRegistrations =
  "/callingData/getAllExternalRegistrations";
export const apiExternalRegistrationTemplate =
  "/callingData/external-registration-template";
export const assignCallingDataToAgents =
  "/callingData/assignCallingDataToAgents";
export const unassignCallingDataFromAgents =
  "/callingData/unassignCallingDataFromAgents";
export const reassignCallingDatatoAgents =
  "/callingData/reassignCallingDatatoAgents";
export const reshuffleCallingDataApi = "/callingData/reshuffleCallingData";
//agents api
export const apiGetAllAgents = "/agent/getAllNonAssignedAgents";
export const apiGetAllAssignedAgents = "/agent/getAllAssignedAgents";
export const assignAgents = "/agent/assignAgents";
export const apigetAllocAndUnalloclist = "/agent/getAllocAndUnalloclist";
export const apireleaseAgent = "/agent/releaseAgents";
export const apiGetCampaignByAgentId = "agent/getCampaignByAgentId";
export const apiGetCallingDataByAgentIdAndCampaignId =
  "/agent/getCallingDataByAgentIdAndCampaignId";
export const getCallingDataByAgent = "/agent/getCallingDataByAgent";
export const apiAgentCallingFilterOptions = "/agent/callingDataFilterOptions";
export const apiAgentCallingFieldSearch   = "/agent/callingDataFieldSearch";
export const apiGetEngagementHistory = "/agent/engagementHistory";

//callHistory api

export const apiCreateHistory = "callHistory/create";
export const apiUpdateHistory = "callHistory/update";
export const apiUploadFile = "/upload/upload";

//callRecoreding
export const apiCreateCallRecording = "callHistory/createCallRecording";

// Tata SmartFlo calling (extension / softphone approach)
export const apiTataCall        = "/tataCalling/call";          // POST — initiate
export const apiTataLive        = "/tataCalling/live";          // GET
export const apiTataHangupCall  = "/tataCalling/hangup";        // PUT  — hangup
export const apiTataUpdateCallId = "/tataCalling/updateCallId"; // PATCH
export const apiTataCallStatus      = "/tataCalling/status";        // GET  /:callId
export const apiTataRecordings      = "/tataCalling/recordings";    // GET  /:callingDataId

//Invoice api
export const apiGenerateAllInvoices = "/invoice/generratAllInvoiceData";
export const apiGetAllInvoicesData = "/invoice/allInvoiceData";
export const apiGetInvoiceAgents = "invoice/getAgentsByProgramManager";
export const apiGetInvoiceAgentDataByMonth =
  "invoice/getAgentInvoicesDataByMonth";
export const apiUpdateAndGenerateInvoice = "invoice/updateAndGenerateInvoice";
export const apiGetInvoicesByPMAndMonth = "invoice/getInvoicesByPMAndMonth";
export const apiGetInvoicesOfAgent = "invoice/getInvoicesOfAgent";
export const apiGetAllInvoicesOfPmMonthWise =
  "invoice/getAllInvoicesOfPmMonthWise";
export const apiInvoiceSalaryDashboard = "invoice/salaryDashboard";
// Invoice generation freeze — PM reads status, RM reads+writes full settings
export const apiInvoiceSettingsStatus = "/invoice/settings/status";
export const apiInvoiceSettingsAdmin   = "/invoice/settings";
export const apiInvoiceSettingsRecent  = "/invoice/settings/recent";

// Contract management
export const apiContractExpiring = "/contract/expiring";
export const apiContractAll      = "/contract";
export const apiContractRenew    = "/contract"; // + /:agentId/renew
export const apiContractReject   = "/contract"; // + /:agentId/reject
export const apiContractEnd      = "/contract"; // + /:agentId/end

//dashboard api

export const apiGetDashboardData = "dashboard/dashboardData";
export const apiAllAgentsReportData = "dashboard/allAgentsReportData";
export const apiCallHistoryReport = "/dashboard/callHistoryReport";
export const apiGetHourlyAnalysis = "/dashboard/hourlyAnalysis";
export const apiGetAdminHourlyAnalysis = "/dashboard/adminHourlyAnalysis";
export const apiGetPMCampaignReport    = "/dashboard/pmCampaignReport";

export const apiGetAttendanceByPmAndMonth =
  "/attendence/attendenceByPmAndMonth";

export const apigetAllAttendenceDetails = "/attendence/getAllAttendenceDetails";

//master db
export const apiGetAllBrands = "/masterdb/brands";
export const apiAddBrand     = "/masterdb/brands";
export const apiGetAllUsersMasterdb = "/masterdb/getAllData";
export const apiGetAllMasterDataWithEngagements =
  "/masterdb/getContactsWithEngagements";
export const apiGetAllCompaniesMasterdb = "/masterdb/getAllCompanyData";
export const apiAddNewCompanyMasterdb = "/masterdb/AddNewCompany";
export const apiGetAllCompanyName = "/masterdb/getAllCompanyName";
export const apiDownloadCompanyNames = "/masterdb/downloadCompanyNames";
export const apiUpdateUserMasterdb = "/masterdb/update";
export const apiAddDataBatchToMasterdb = "/masterdb/batchCreateFromExcel";
export const apiGetBatchJobStatus      = "/masterdb/batchJobStatus";
export const apigetDropdownFiltersData = "/masterdb/getDropdownFilters";
export const apiGetCompanyById = "/masterdb/getCompanyDataById";
export const apiMergeCompanies = "/masterdb/mergeCompanies";
export const apiIndividualSearch = "/masterdb/individualSearch";
export const apiAssignIndividualSearch = "/masterdb/assignIndividualSearch";
// export const apiGetFiltersStats = "/masterdb/getFiltersStats";
export const apiGetFiltersStats = "/filtration/callingDataFilter";
export const apiClientCallingDataFilter = "/filtration/clientCallingDataFilter";
export const apiGetAllFilteredDataSummary =
  "/filtration/getPrevCampFiltersByCampaignId";

//magicLinks
export const apiGenerateMagicLink = "/filtration/generate";
export const apifilterResultsSummary = "/filtration/filterResultsSummary";

//for updating campaign data source type and stage
export const apiUpdateCampaignDataSourceType =
  "/campaign/updateCampaignDataSourceType";
export const apiUpdateCampaignStage = "/campaign/updateCampaignStage";

export const apiGetAllcompaniesMatchedData =
  "/filtration/companiesMatchedDataWithExcel";
export const apiMatchJobStatus = "/filtration/matchJobStatus";
export const apiGetClientMatchData = "/filtration/clientMatchData";
export const apiGetClientMatchSessionData = "/filtration/clientMatchData";
export const apiGetClientMatchEntries = "/filtration/clientMatchEntries";
export const apiGetCrossTab = "/filtration/crossTab";
export const apiUpdateFilterTag = "/filtration";
export const apiDownloadFilteredData = "/filtration/downloadFilteredData";
export const apiUpdateClientMatchAction = "/filtration/clientMatchData";

//for assignCallingDataToCampaign
export const apiAssignCallingDataToCampaign =
  "/filtration/assignCallingDataToCampaign";
export const apiAssignCallingDataToCampaignBoth =
  "/filtration/assignCallingDataToCampaignBoth";
export const assignCallingDataToCampaignClientSuggested =
  "/filtration/assignCallingDataToCampaignClientSuggested";

//for approval data
export const apiGetPendingEditApprovals =
  "/callingDataEditApproval/pending-edit-approvals";
export const apiApproveOrRejectEditApproval =
  "/callingDataEditApproval/approve-reject-edit-request";

//webhooks related apis
export const apiGetAllEmailData = "/webhook/GetAllMailSentStatus";

//email teplate related apis
export const apiGetAllTemplateData = "/template/getAllTemplateData";
export const apiCreateTemplate = "/template/createAndLinkTemplate";
export const apiUpdateTemplate = "/template/updateTemplate";
export const apiSendEmailWithTemplate = "/mailercloud/sendEmailWithTemplate";
export const apiGetMailerCloudTemplateDetails =
  "/template/getMailerCloudTemplateDetails";
export const apiGetAllMailerCloudTemplates = "/mailercloud/templates";
export const apiGetMailerCloudTemplateByName = "/mailercloud/template";
export const apiGetMailerCloudSenders = "/mailercloud/senders";
export const apiGetAllEmailStatus = "/GetAllEmailStatus";

export const apiUploadLinkedProfilesCsv = "/linkedin/uploadLinkedinCsv";
export const apiGetAllLiinkedinProfiles = "/linkedin/getAllEnrichedProfiles";
export const apiDownloadLinkedinProfiles = "/linkedin/downloadEnrichedProfiles";

// reconfirmation campaign
export const apiCreateReconfirmationCampaign = "/campaign/createReconfirmation";
export const apiGetReconfirmationCampaigns = "/campaign/getReconfirmationCampaigns";
export const apiUpdateAllowedTemplates = "/campaign/updateAllowedTemplates";
export const apiGetCampaignAllowedTemplates = "/campaign/allowedTemplates";

// Campaign Report
export const apiGenerateCampaignReport  = "/campaignReport/generate";
export const apiAllCampaignReportHistory = "/campaignReport/history";
export const apiCampaignReportHistory   = "/campaignReport/history";
export const apiCampaignReportById      = "/campaignReport";
export const apiSharedCampaignReport    = "/campaignReport/shared";
export const apiCampaignReportDownload  = "/campaignReport";

//Whatapp related apis
export const apiResetNoResponse = "/callingData/resetNoResponse";
export const apiGetAllWhatsappTemplates = "/whatsapp/getAllWhatsappTemplates";
export const apiSendWhatsappMessage = "/whatsapp/sendTemplateMessage";
